var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('router-view'),(_vm.executingSAMLLogin)?_c('div',{staticClass:"sso-loading"},[_c('h1',[_vm._v("Realizando login por SSO...")])]):_vm._e(),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }